import { Theme, ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { NavBar, NavBarItem } from "./components/NavBar";
import { HomePage } from "./components/pages/home/HomePage";
import { LoginPage } from "./components/pages/login/LoginPage";
import { RetailersPage } from "./components/pages/retailers/RetailersPage";
import { SettingsPage } from "./components/pages/settings/SettingsPage";
import { UsersPage } from "./components/pages/users/UsersPage";
import { VendorsPage } from "./components/pages/vendors/VendorsPage";
import { useUserContext } from "./components/UserContext";

import themes from "./themes.json";
import { HelpPage } from "./components/pages/help/HelpPage";

// const theme = unstable_createMuiStrictModeTheme();

const PrivateRoute = ({ Component }: any) => {
  const ctx = useUserContext();
  return ctx.isSignedIn() ? <Component /> : <Navigate to="/login" />;
};

const PublicRoute = ({ Component }: any) => {
  const ctx = useUserContext();
  return ctx.isSignedIn() ? <Navigate to="/" /> : <Component />;
};


function App() {
  const { user, isAdmin, themeName } = useUserContext();

  const initTheme = createTheme(themes[themeName] as any);
  const [theme, setTheme] = useState<Theme>(initTheme);

  useEffect(() => {
    const newTheme = createTheme(themes[themeName] as any);
    setTheme(newTheme);
  }, [themeName]);

  const getNavBarItems = () : NavBarItem[] => {
    const items : NavBarItem[]  = [
      { name: "Home", location: "/" },
      { name: "Vendors", location: "/vendors" },
      { name: "Retailers", location: "/retailers" },
      { name: "Settings", location: "/settings" },
    ];
    if (isAdmin()) {
      items.push({ name: "Users", location: "/users" });
    }
    items.push({ name: "", location: "" });
    items.push({ name: "Help", location: "/help" });
    return items;
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<PublicRoute Component={LoginPage} />} />
        <Route path="/" element={<NavBar items={getNavBarItems()} />}>
          <Route index element={<PrivateRoute Component={HomePage} />} />
          <Route path="/vendors" element={<PrivateRoute Component={VendorsPage} />} />
          <Route path="/retailers" element={<PrivateRoute Component={RetailersPage} />} />
          <Route path="/settings" element={<PrivateRoute Component={SettingsPage} />} />
          {isAdmin() && <Route path="/users" element={<PrivateRoute Component={UsersPage} />} />}
          <Route path="/help" element={<PrivateRoute Component={HelpPage} />} />
        </Route>
        <Route path="*" element={<PublicRoute Component={LoginPage} />} />
      </Routes>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          top: 80,
        }}
      />
    </ThemeProvider>
  );
}

export default App;
